import React from 'react';

const VideoLabeling = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl font-bold">Video Labeling</h1>
    </div>
  );
};

export default VideoLabeling;
